import { DataTable } from './DataTable'
import { YhBox } from '@/components/YhBox'
import { Button } from 'antd'
import { ExportOutlined } from '@ant-design/icons'
import { useDangerModel } from '../dangerModel'
import './statistics.less'

export const DataBox = () => {
    const { exportListData, dangerTab, switchDangerTab } = useDangerModel()

    const action = (
        <>
            <Button.Group style={{ marginRight: '12px' }}>
                <Button type={dangerTab === 'scheduling' ? 'primary' : 'default'} onClick={() => switchDangerTab('scheduling')}>
                    排班提报
                </Button>
                <Button type={dangerTab === 'inspection' ? 'primary' : 'default'} onClick={() => switchDangerTab('inspection')}>
                    巡查员提报
                </Button>
            </Button.Group>
            <Button style={{ marginBottom: '5px' }} shape="round" type="link" onClick={() => exportListData()}>
                <ExportOutlined />
                导出
            </Button>
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 230px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
